import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { AllPublicGroupRes } from "../../types/ResType";

export const usePublicGroupList = ({ group_name }: { group_name?: string }) => {
  return useQuery<AllPublicGroupRes, Error>(
    ["get-public-groups", group_name],
    async () => {
      const response = await axiosInstance.post<AllPublicGroupRes>("get-public-groups", {
        group_name,
      });
      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  );
};
